




















































import { Prop, Vue, Component } from "vue-property-decorator";

import IconBase from "@/common/components/atoms/IconBase.vue";
import IconStepYet from "@/common/components/icons/IconStepYet.vue";
import IconStepOver from "@/common/components/icons/IconStepOver.vue";
import IconStepCurrent from "@/common/components/icons/IconStepCurrent.vue";

import commons from "@/common/store/modules/commons";
import { mapState } from "vuex";

@Component({
  components: {
    IconBase,
    IconStepYet,
    IconStepOver,
    IconStepCurrent
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  }
})
export default class TheFormStep extends Vue {
  @Prop({ type: Number, required: true }) step!: number;
  @Prop({ type: Array, required: true }) options!: any;
  @Prop({ type: Boolean, required: false }) isAdmin!: boolean;
}
